"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TABS_DATA_HOOKS;
(function (TABS_DATA_HOOKS) {
    TABS_DATA_HOOKS["leftNavButton"] = "left-nav-btn";
    TABS_DATA_HOOKS["rightNavButton"] = "right-nav-btn";
    TABS_DATA_HOOKS["scrollableTabs"] = "scrollable-tabs";
    TABS_DATA_HOOKS["tab"] = "tab-item";
})(TABS_DATA_HOOKS = exports.TABS_DATA_HOOKS || (exports.TABS_DATA_HOOKS = {}));
var TABS_DATA_KEYS;
(function (TABS_DATA_KEYS) {
    TABS_DATA_KEYS["alignment"] = "data-alignment";
    TABS_DATA_KEYS["variant"] = "data-variant";
    TABS_DATA_KEYS["skin"] = "data-skin";
    TABS_DATA_KEYS["navButtons"] = "data-navbuttons";
    TABS_DATA_KEYS["mobile"] = "data-mobile";
    TABS_DATA_KEYS["rtl"] = "data-rtl";
    TABS_DATA_KEYS["tabIndex"] = "data-tab-index";
    TABS_DATA_KEYS["tabIsActive"] = "data-tab-active";
})(TABS_DATA_KEYS = exports.TABS_DATA_KEYS || (exports.TABS_DATA_KEYS = {}));
//# sourceMappingURL=dataHooks.js.map